export default function getStudentActivityProgress({
  progresses,
  activityConf,
}) {
  const miniactivities = getMiniactivitiesConf(activityConf);

  return miniactivities.map((miniactivityConf) => {
    const { progressAttempts, correctnessAttempts } =
      getNonEmptyAttemptsFilteredByMiniactivity(miniactivityConf)(progresses);

    progressAttempts.sort((a, b) => b.progress - a.progress);
    correctnessAttempts.sort((a, b) => b.correct - a.correct);

    const progressSlots = progressAttempts
      .slice(0, miniactivityConf.options?.repetitions || undefined)
      .map((progress, index) => ({
        progress: progress.progress,
        correct: correctnessAttempts[index].correct,
        progressUpdatedAt: progress.updatedAt,
        correctUpdatedAt: correctnessAttempts[index].updatedAt,
      }));

    return wrapWithMetaData(miniactivityConf)(progressSlots);
  });
}

const getMiniactivitiesConf = (activityConf) =>
  activityConf?.miniactivities || [
    {
      ...(activityConf || {}),
    },
  ];

const getNonEmptyAttemptsFilteredByMiniactivity =
  (miniactivityConf) => (progresses) => {
    const progressAttempts = [];
    const correctnessAttempts = [];

    if (progresses) {
      for (const progress of progresses) {
        if (
          !miniactivityConf.miniactivityType ||
          progress?.data?.miniactivityType == miniactivityConf.miniactivityType
        ) {
          if (progress.data.progress > 0) {
            progressAttempts.push({
              progress: progress.data.progress,
              updatedAt: progress.updatedAt,
            });
            correctnessAttempts.push({
              correct: progress.data.correct,
              updatedAt: progress.updatedAt,
            });
          }
        }
      }
    }
    return { progressAttempts, correctnessAttempts };
  };

const wrapWithMetaData = (activityConf) => (progressSlots) => {
  const {
    options: { repetitions } = {},
    progress,
    correctness,
    canLoadProgress,
    miniactivityType,
  } = activityConf;
  const wrappedProgresses = {
    progressSlots,
    repetitions,
    progress,
    correctness,
    canLoadProgress,
  };
  if (miniactivityType) wrappedProgresses.miniactivityType = miniactivityType;
  return wrappedProgresses;
};
